import {Alert, Flex} from "antd";
import {WarningIcon} from "@phosphor-icons/react";
import React from "react";
import {useViewerStore} from "../../../../../../store/store";

interface RoofSquareUnavailableProps {
    headerAction?: React.ReactNode;
}

const RoofSquareUnavailable: React.FC<RoofSquareUnavailableProps> = ({ headerAction }) => {

    const isRoofSquareDataUnavailable = useViewerStore((state) => state.isRoofSquareDataUnavailable);
    const roofSquareErrorMessage = useViewerStore((state) => state.roofSquareErrorMessage);

    return (
        <Flex
            vertical
            gap={10}
        >
            <Flex justify={'space-between'} align={'center'} gap={10}>
                <Flex gap={10} justify={'left'} align={'center'}>
                    <WarningIcon className='theme-based-text-color' size={32}/>
                    <span className='theme-based-text-color'>{isRoofSquareDataUnavailable ? 'Roof Square Error' : ''}</span>
                </Flex>
                {headerAction ?? null}
            </Flex>
            <Alert
                style={{
                    color: "indianred"
                }}
                message={roofSquareErrorMessage}
                type= {isRoofSquareDataUnavailable ? 'error' : 'warning'}
                showIcon
            />
        </Flex>
    )
}

export default RoofSquareUnavailable;